import React from 'react';
import { Input } from '@flixbus/honeycomb-react';
import { useVoucherFormContext } from '../../Context';
import { MinimumTicketsAmountRule } from '../../../../types/Rules';

const MinimumTicketsAmount = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const rule = rules.filter(r => r.type === 'minimum_tickets_amount')[0] as
    | MinimumTicketsAmountRule
    | undefined;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = e;

    const parsedValue = value === '' ? 0 : parseInt(value);

    const finalValue = isNaN(parsedValue) ? 0 : parsedValue;

    handleRuleChange(
      {
        type: 'minimum_tickets_amount',
        count: finalValue,
      },
      finalValue === 0,
    );
  };

  return (
    <Input
      name='minimum_tickets_amount'
      id='minimum_tickets_amount'
      label={<>Minimum number of tickets</>}
      type='number'
      info='1 ticket = 1 pax or 1 trip'
      min={0}
      value={rule !== undefined ? rule.count.toString() : '0'}
      onChange={handleChange}
    />
  );
};

export default MinimumTicketsAmount;
